module.exports = __webpack_public_path__ + "media/images/features/3/og-image-478079f0e3fe83433b4844eefc33ca09.jpg";